import mixpanel from 'mixpanel-browser'

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN)

const track = (event, properties) => {
  mixpanel.track(event, properties)
}

const identify = ({ distinctId }) => {
  mixpanel.identify(distinctId)
}

export { track, identify }
